import { render, staticRenderFns } from "./NoticeNew.vue?vue&type=template&id=a5b66f64&scoped=true&"
import script from "./NoticeNew.vue?vue&type=script&lang=js&"
export * from "./NoticeNew.vue?vue&type=script&lang=js&"
import style0 from "./NoticeNew.vue?vue&type=style&index=0&id=a5b66f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b66f64",
  null
  
)

export default component.exports